import { getCropColor, getCropCssColor } from "@omnia/shared/fields"
import { getApplicationViewModels } from "../../../applications/applications"
import { ApplicationVm } from "../../../applications/applicationVm"
import { FieldViewModel, ICrop } from "../../../omnia"
import { StockVm } from "../../../stocks/stockVm"
import { INutritionPlan, INutritionService, NutrientType } from "../../../types"
import { getPlanPillText } from "../../../utils"
import { CroppingGroupLiteVm } from "./croppingGroupLite"
import { colorToCss, getWhiteBlackForegroundFromBackgroundColor } from "@omnia/shared/color/color"
import { getDistinctValues } from "@omnia/shared/utils/array"

export class PlanVm {

    public cropping: FieldViewModel[];
    public precision: boolean;

    public readonly singleCrop: ICrop

    private _applications: ApplicationVm[];

    public croppingGroups: CroppingGroupLiteVm[];

    public readonly pillText = getPlanPillText(this.name)
    public readonly pillStyle: {}

    public readonly planInfo = getPlanInfo(this)


    constructor(
        public plan: INutritionPlan,
        svc: INutritionService,
        stocks: StockVm[],
        public readonly key = plan.NutritionPlanId,
        public readonly visible = !plan.Restricted
    ) {

        this.cropping = svc.cropping.filter(c => plan.Cropping.filter(cc => cc.CroppingId === c.croppingId).length);

        this.precision = !!plan.Precision;

        this.singleCrop = getSingleCrop(this.cropping)
        this.pillStyle = getPillStyle(this.singleCrop)

        this._applications = getApplicationViewModels(plan.Applications, svc, stocks)

        this.croppingGroups = CroppingGroupLiteVm.groupByVariety(this.cropping);

    }

    get name(): string {
        return this.plan.Name;
    }

    get Name(): string {
        return this.plan.Name;
    }

    get applications(): ApplicationVm[] {
        return this._applications
    }

    get description(): string {
        return this.name
    }

    getSingleCropColor() {
        if (this.singleCrop) {
            return getCropCssColor(this.singleCrop);
        }
    }

    getCropColor(crop: ICrop) {
        return getCropCssColor(crop);
    }

    checkApplicationsForNutrient(nutrientType: NutrientType): boolean {

        let apps = this.plan.Applications;

        if (!apps) {
            return false;
        }

        if (apps.some(a => a.TargetNutrient == nutrientType)) {
            return true;
        }

        // TODO : Check nutrient in products

        return false;

    }


}

function getSingleCrop(cropping: FieldViewModel[]) {

    let crops = cropping.map(c => c.cropping.Crop);

    crops = getDistinctValues(crops, c => c, c => c.CropId);

    return (crops.length == 1 ? crops[0] : null);

}



function getPillStyle(crop: ICrop) {

    var c: number[];

    c = crop ? getCropColor(crop) : [66, 66, 66];

    var f = getWhiteBlackForegroundFromBackgroundColor(c);

    return {
        "background-color": colorToCss(c, false),
        "color": f ? "#fff" : "#000"
    }

}

function getPlanInfo(plan: PlanVm) {

    const getUniqueValues = (s: (c: FieldViewModel) => string) => {
        const cropping = plan.cropping ?? []
        return cropping.map(s).filter(n => n).unique(n => n)
    }

    return {
        name: plan.name,
        fields: getUniqueValues(c => c.fieldName),
        crops: getUniqueValues(c => c.getCropName())
    }

}
